import axios from 'axios';
import { apiWhatsApp } from './api';

export interface UploadUrlResponse {
  get: string;
  post?: string;
  key?: string;
}

export const FileService = {
  async getUploadUrl(fileName: string, fileType: string, token: string): Promise<UploadUrlResponse> {
    const { data } = await apiWhatsApp.get<UploadUrlResponse>('files/publishurl', {
      params: {
        fileName,
        fileType,
      },
      headers: { token },
    });

    return data;
  },

  async uploadFile(url: string, file: File, token: string): Promise<void> {
    await axios.put(url, file, {
      headers: {
        'Content-Type': file.type,
      },
      transformRequest: [(data) => data],
      maxBodyLength: Infinity,
      maxContentLength: Infinity,
    });
  },
};
